import { Space } from 'shared/components/Space';
import { IArticleSpace } from 'editorial/types/ArticleSpace';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import {
  ARTICLE_BODY_DESKTOP_PADDING,
  ARTICLE_BODY_MOBILE_PADDING,
} from 'editorial/styles/articleStyles';

export const ArticleSpace = (section: IArticleSpace) => {
  const { id, uuid } = section || {};
  const {
    isMobile,
    windowSize: { width },
  } = useWindowSize();
  const maxWidth =
    width - (isMobile ? ARTICLE_BODY_MOBILE_PADDING * 2 : ARTICLE_BODY_DESKTOP_PADDING * 2);

  return (
    <div id={`space-section-${uuid || id}`}>
      <Space section={section} maxWidth={maxWidth} />
    </div>
  );
};
